import { MenuItem } from './menu-item';
import { MenuMode } from './menu-mode.enum';
import { MenuStates } from './menu-states.enum';

export interface MainHeaderMenu {
    state: MenuStates;
    mode: MenuMode;
    title: string;
    items: MenuItem[];
    showSearch?: boolean;

    addMenuItem(menuItem?: MenuItem | null): MainHeaderMenu;
}

export abstract class BaseMainHeaderMenu implements MainHeaderMenu {
    mode: MenuMode;
    state: MenuStates;
    title: string;
    items: MenuItem[] = [];
    showSearch?: boolean;

    constructor(mode: MenuMode, state: MenuStates, opts: { title: string; items?: MenuItem[]; showSearch?: boolean }) {
        this.mode = mode;
        this.state = state;
        this.title = opts.title || '';
        this.showSearch = opts.showSearch || false;

        if (opts.items) {
            opts.items.forEach((item) => this.addMenuItem(item));
        }
    }

    addMenuItem(menuItem?: MenuItem | null): MainHeaderMenu {
        if (menuItem) {
            this.items.push(removeSingleChildWithSameRouteAsParent(menuItem));
        }
        return this;
    }
}

function removeSingleChildWithSameRouteAsParent(menu: MenuItem): MenuItem {
    if (menu.menu?.length !== 1) {
        return menu;
    }

    if (menu.menu[0].routePath !== menu.routePath) {
        return menu;
    }

    return { ...menu, menu: null };
}
